// import { createWeb3Modal } from '@web3modal/wagmi/react';
// import { defaultWagmiConfig } from '@web3modal/wagmi/react/config';
// import { WagmiProvider } from 'wagmi';
// import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// import WalletConnectContext from './WalletConnectContext';

// const queryClient = new QueryClient();

// const PROJECT_ID = import.meta.env.VITE_PROJECT_ID;

// const metadata = {
//   name: 'Web3Modal',
//   description: 'WalletConnect',
//   url: 'https://cryllex.com',
//   icons: ['https://avatars.githubusercontent.com/u/37784886']
// }

// const WalletConnectComponent = ({ chains = [], children }) => {

//   const config = defaultWagmiConfig({
//     chains, // required
//     projectId: PROJECT_ID, // required
//     metadata, // required
//     auth: {
//       email: false,
//       socials: [],
//       showWallets: true,
//       walletFeatures: true,
//     }
//   });

//   createWeb3Modal({
//     wagmiConfig: config,
//     projectId: PROJECT_ID,
//     enableAnalytics: true,
//   });

//   return (
//     <WagmiProvider config={config}>
//       <QueryClientProvider client={queryClient}>
//         <WalletConnectContext.Provider value={config}>
//           {children}
//         </WalletConnectContext.Provider>
//       </QueryClientProvider>
//     </WagmiProvider>
//   );
// }

// export default WalletConnectComponent;



// const WalletConnectComponent = ({ chains = [], children }) => {
//   return <div>
//     {children}
//   </div>
// }

// export default WalletConnectComponent



import { createAppKit } from '@reown/appkit/react'
import { WagmiProvider } from 'wagmi'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'
import { arbitrum, avalanche, base, bsc, mainnet, optimism, polygon, solana, tron } from "@reown/appkit/networks"
import { ChainsContext } from './ChainsContext'

const chains = [arbitrum, avalanche, base, bsc, mainnet, optimism, polygon, solana, tron];
const queryClient = new QueryClient();
const projectId = import.meta.env.VITE_PROJECT_ID;

const metadata = {
  name: 'Cryllex',
  description: ' ',
  url: 'https://cryllex.com',
  icons: ['https://cryllex.biz/favicon.ico']
}

// 4. Create Wagmi Adapter
const wagmiAdapter = new WagmiAdapter({
  networks: chains,
  projectId,
  ssr: true,
})

// 5. Create modal
createAppKit({
  adapters: [wagmiAdapter],
  networks: chains,
  projectId,
  metadata,
  features: {
    email: false,
    analytics: false,
    socials: [],
  }
})

export default function WalletConnectComponent({ children }) {

  return (
    <WagmiProvider config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <ChainsContext.Provider value={chains}>
          {children}
        </ChainsContext.Provider>
      </QueryClientProvider>
    </WagmiProvider>
  )
}